import { capitalize } from '@repo-level/core-front';
import { ButtonCross } from 'components/buttons';
import { useTheme } from 'hooks/theme';
import { forwardRef } from 'react';
import { ScSelectButton } from './styled';

import { SelectButtonProps } from '../../types';
import { ImageComponent } from 'components/Image';

export const ProfileSelectButton = forwardRef<
  HTMLDivElement,
  SelectButtonProps
>(
  (
    {
      selectedOption,
      handleOpen,
      handleReset,
      placeholder,
      selected,
      error,
      hideErrorMessage,
      disabled,
      defaultValue,
      canReset,
      selectedOptionWithoutIcon,
      active,
      ...scProps
    },
    ref
  ) => {
    const { arrowLeftIcon: Arrow } = useTheme();

    return (
      <ScSelectButton
        ref={ref}
        {...scProps}
        onClick={handleOpen}
        selected={!!selected}
        canReset={canReset}
        disabled={disabled}
        active={!!active}
        error={error != null && error !== ''}
      >
        <div className="border" />
        <div className="content">
          <div
            className={`value ${
              selectedOption?.icon != null && !selectedOptionWithoutIcon
                ? `with-icon`
                : ''
            }`}
          >
            {!selectedOptionWithoutIcon && selectedOption?.icon != null && (
              <ImageComponent
                width={20}
                height={20}
                src={selectedOption.icon}
                alt=""
              />
            )}
            {(selectedOption || defaultValue) && (
              <div className="name">
                {selectedOption == null
                  ? defaultValue
                  : selectedOption.nameV ?? selectedOption.name}
              </div>
            )}
            {selectedOption == null &&
              defaultValue == null &&
              placeholder != null && (
                <span className="placeholder">{capitalize(placeholder)}</span>
              )}
          </div>
          <div className="select-btn-action">
            {selected && canReset ? (
              <ButtonCross relative small gray onClick={handleReset} />
            ) : (
              <Arrow />
            )}
          </div>
        </div>
      </ScSelectButton>
    );
  }
);
